import { FC } from 'react';
import { Typography, GridProps } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

interface DeloitteSectionProps extends GridProps {
    title: string;
    id?: string;
    children: any;
    variant?: "sides";
}
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '32px'
    },
    title: {
        fontWeight: 700,
        fontSize: '2.8em'
    }
}));
export const DeloitteSection: FC<DeloitteSectionProps> = (props) => {
    const { title, children, id, variant } = props;
    const classes = useStyles();
    if (!variant || !children)
        return (
            <Grid container component="section" id={id} direction={props.direction ?? "row"} spacing={props.spacing ?? 4} justifyContent={props.justifyContent ?? "center"} alignItems={props.alignItems ?? "flex-start"} className={clsx(classes.root, props.className)}>
                <Grid xs={12}>
                    <Typography className={classes.title}>{title}</Typography>
                </Grid>
                <Grid container xs={12} p={2}>
                    {children}
                </Grid>
            </Grid>
        );
    else {
        const firstChild = children[0];
        const otherChildren = children.slice(1);
        return (
            <Grid container component="section" id={id} direction={props.direction ?? "row"} spacing={props.spacing ?? 4} justifyContent={props.justifyContent ?? "center"} alignItems={props.alignItems ?? "flex-start"} className={clsx(classes.root, props.className)}>
                <Grid container xs={12} sm={8}>
                    <Grid xs={12}>
                        <Typography className={classes.title}>{title}</Typography>
                    </Grid>
                    <Grid xs={12} p={1}>
                        {firstChild}
                    </Grid>
                </Grid>
                <Grid container xs={12} sm={4}>
                    {otherChildren}
                </Grid>
            </Grid>)
    }
}